module.exports = __webpack_public_path__ + "img/img_notice_pop_02.c6b0a79d.png";